import AccordianSlide from '../AccordianSlide'

export default function OurProductsSlide (props) {
  return (
    <AccordianSlide
      title='Our Products'
      stageName='Learning about Aragon'
      description='Aragon provides an open-source suite of applications and services that enable new forms of organization for global communities, DAOs.'
      accordianData={[
        {
          title: 'Aragon Client',
          image: './imgs/products/client.png',
          body:
            'The Aragon client is a full platform that can create and manage decentralized organizations by running Aragon apps inside it. It contains the tools needed for a community to organize its decentralized life.'
        },
        {
          title: 'Aragon Govern',
          image: './imgs/products/govern.png',
          body:
            'Aragon Govern is a framework for frictionless DAO governance with on-chain execution and plug-in dispute resolution. It builds on the "Optimistic" concept, in which we assume actors are acting rationally and with good intentions, until proven otherwise.'
        },
        {
          title: 'Aragon Voice',
          image: './imgs/products/voice.png',
          body:
            'An open source free voting infrastructure with an easy access to anyone. With a wide variety of voting types, including single and multiple questions, real-time or encrypted results, it helps increase token holder engagement and meet minimum participation thresholds.'
        },
        {
          title: 'Aragon Court',
          image: './imgs/products/court.png',
          body:
            'It is a decentralized dispute resolution protocol that can handle subjective disputes that cannot be resolved by smart contracts alone. Through a network of incentivized guardians drafted for each dispute, ready to intervene and arbitrate on a ruling, it channels human-readable agreements, with common-sense.'
        },
        {
          title: 'vocdoni',
          image: './imgs/products/vocdoni.png',
          body:
            'Vocdoni is a suite of secure solutions for digital voting, where everybody can participate, including voters, institutions and third parties.'
        }
      ]}
      rounded={false}
      {...props}
    />
  )
}
